<template>
  <v-card-text v-show="show">

    <v-row>
      <v-col>
        <v-text-field autofocus v-model="code_name" label="Area code or City name" hide-details dense outlined :disabled="addNumberLoading" v-on:keyup.enter="fetchNumbers(1)">
          <v-icon slot="append" color="secondary" class="areacodecity-icon" v-if="allowSearch" @click="fetchNumbers(1)">search</v-icon>
        </v-text-field>
      </v-col>
    </v-row>

    <Loader v-if="numbersLoading" />

    <template v-if="numberPool.length!==0&&!numbersLoading">
      <v-row>
        <template v-for="(num,numi) in numberPool">
          <v-col :key="numi" cols="12" md="4">
            <v-checkbox v-model="range[num.id]" :label="(code_name==='*')?`(${num.area_code}) ${num.number}`:num.number" @click="_updateNumbersToSend(range)" dense hide-details :class="`mt-0 numberBox ${num.rating}`"></v-checkbox>
          </v-col>
        </template>
      </v-row>

      <v-row v-if="searched&&numberPool.length===0&&!numbersLoading"><v-col>No numbers found</v-col></v-row>

      <v-row justify="center">
        <v-col cols="1"><v-icon v-if="pagination.currentPage>1" @click="goToPage('prev')">{{icons.left}}</v-icon></v-col>
        <v-col cols="2" class="text-center"><p><b>{{pagination.currentPage}} / {{pagination.totalPages}}</b></p></v-col>
        <v-col cols="1" class="text-right"><v-icon v-if="pagination.currentPage<pagination.totalPages" @click="goToPage('next')">{{icons.right}}</v-icon></v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex justify-start align-center mb-4 mt-n4">

          <div class="dotExplain FREE mr-6 dark_grey--text"><span class="font-weight-bold">Bronze</span> - Included</div>
          <div class="dotExplain SILVER mr-6 dark_grey--text"><span class="font-weight-bold">Silver</span> - £20 upfront | £5 monthly</div>
          <div class="dotExplain GOLD dark_grey--text"><span class="font-weight-bold">Gold</span> - £50 upfront | £10 monthly</div>

        </v-col>
      </v-row>

    </template>
  </v-card-text>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js';

import Loader from "@/components/Misc/Loader";

export default {
  components: { Loader },

  props: { currentTabType:String, addNumberLoading:Boolean, updateMaxWidth:Function, updateNumbersToSend:Function, displayResetBtn:Function },

  data() {
    return {
      show: false,
      code_name: '',
      numberPool: [],
      numbersLoading: false,
      range: {},
      searched: false,
      icons: {
        left: mdiChevronLeft,
        right: mdiChevronRight,
      },
    };
  },

  mounted() {
    this.$root.$on('ADD_NUMBERS_DIALOG_GEO_RESET', this.resetNumberPool);
    this.onCurrentTabTypeChange(this.currentTabType);
  },

  computed: {
    ...mapGetters('numbers', ['pagination']),
    ...mapState('numbers', ['numbers']),
    ...mapGetters('products', ['getCurrentProduct']),
   
   allowSearch(){
      if(this.isText){
        return this.code_name.length>0;
      }else{
        return this.code_name.length>2;
      }
    },

    isText(){
      let reg = /[^0-9.]/g;
      return reg.test(this.code_name);
    },
  },

  watch: {
    currentTabType(val) {
      this.onCurrentTabTypeChange(val);
    },
    numberPool(val) {
      this.updateParentByNumberPool(val);
    },
  },

  methods: {
    ...mapActions('numbers', ['getNumbersBySearch', 'resetNumbers', 'updatePagination', 'resetNumberPagination']),

    onCurrentTabTypeChange(val) {
      let isCurrentTabTypeMatched = val === 'geo';
      if (isCurrentTabTypeMatched) {
        this._updateNumbersToSend(this.range);
        this.updateParentByNumberPool(this.numberPool);
      }
      this.show = isCurrentTabTypeMatched;
    },

    updateParentByNumberPool(numberPool) {
      this._updateMaxWidth(numberPool);
      this.displayResetBtn(numberPool.length !== 0);
    },

    _updateMaxWidth(numberPool) {
      this.updateMaxWidth(numberPool.length !== 0 ? 750 : 350);
    },

    async goToPage(type) {
      let cpage = parseInt(this.pagination.currentPage);
      let page = (type==='next')?cpage+1:cpage-1;
      await this.fetchNumbers(page);
    },

    async fetchNumbers(page) {
      await this.updatePagination(page);
      this.resetNumbers();
      this.range = {};
      this.numbersLoading = true;
      let search = {
        value: this.code_name,
        type: this.isText?'query':'area_code',
        supplier: this.getCurrentProduct.supplier === 'Centile' ? 'ENREACH' : this.getCurrentProduct.supplier
      };

      await this.getNumbersBySearch({search:search});
      this.mapNumberPool(this.numbers);
      this.numbersLoading = false;
      this.searched = true;
    },

    mapNumberPool(numbers) {
      numbers.sort(function(a,b){return a['number']-b['number']});
      let rowCount = Math.floor(numbers.length/3);
      if(numbers.length%3>0){ rowCount++; }
      this.numberPool = [];

      numbers.forEach((num,numi) => {
        if(this.numberPool[numi%rowCount]===undefined){ this.numberPool[numi%rowCount] = []; }
        this.numberPool[numi%rowCount].push(num);
      });

      this.numberPool = this.numberPool.flat();
    },

    _updateNumbersToSend(range) {
      this.updateNumbersToSend(
        Object.entries(range).reduce((acc, [key, val]) => {
          if (val) {
            acc.push({
              number_pool_id: parseInt(key),
              non_geographic: false,
            });
          }
          return acc;
        }, [])
      );
    },
    
    resetNumberPool() {
      this.resetNumbers();
      this.resetNumberPagination();
      this.numberPool = [];
      this.code_name = '';
      this.range = {};
      this.searched = false;
    },
  },
}
</script>

<style lang="scss">

  .numberBox {
    .v-label {
      position: relative;

      &:after {
        $radius: 16px;
        content: '';
        display: block;
        position: relative;
        margin-left: 10px;
        margin-top: -2px;
        width: $radius;
        height: $radius;
        border-radius: $radius / 2;
      }
    }

    &.FREE .v-label:after { background: #CD7F32; }
    &.SILVER .v-label:after { background: #C4C4C4; }
    &.GOLD .v-label:after { background: #FFD700; }
  }

  .dotExplain {
    $radius: 16px;

    position: relative;
    padding-left: $radius + 7px;

    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 2px;
      left: 0;
      width: $radius;
      height: $radius;
      border-radius: $radius / 2;
    }

    &.FREE:before { background: #CD7F32; }
    &.SILVER:before { background: #C4C4C4; }
    &.GOLD:before { background: #FFD700; }
  }

</style>
